import ArticleListPage from './ArticleList/ArticleListPage';
import ArticlePage from './Article/ArticlePage';

import { PATH_KNOWLEDGE, PATH_KNOWLEDGE_ARTICLE } from './paths';

const routes = [
    {
        path: PATH_KNOWLEDGE,
        component: ArticleListPage,
        private: true,
        exact: true,
        title: 'route-title/knowledge',
        mobileAppTabIdentifier: 'knowledge',
    },
    {
        path: PATH_KNOWLEDGE_ARTICLE,
        component: ArticlePage,
        private: true,
        exact: true,
        title: 'route-title/knowledge',
        mobileAppTabIdentifier: 'knowledge',
    },
    {
        path: '/knowledge',
        redirectTo: '/knowledge/all',
        exact: true,
    },
];

export { routes };
